
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/hebergement",
      function () {
        return require("private-next-pages/[region]/hebergement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/hebergement"])
      });
    }
  